var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"w-100 text-center mt-3",attrs:{"dir":"ltr"}},[_vm._v("Getting Book Names...")])
}
var staticRenderFns = []

export { render, staticRenderFns }